import React from 'react';
import { Zap } from 'lucide-react';
interface LogoProps {
  className?: string;
  showText?: boolean;
}
export function Logo({
  className = '',
  showText = true
}: LogoProps) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-427" data-mp="3q9ursoi3ndt4">
      <div className="relative flex items-center justify-center w-10 h-10" data-id="element-428" data-mp="3qbe98ifhruwh">
        {/* Wheel/Tire base */}
        <div className="absolute inset-0 rounded-full border-4 border-[#1a1a1a] bg-[#0A0A0A] shadow-[0_0_10px_rgba(0,0,0,0.5)]" data-id="element-429" data-mp="3v6la7ihdmlhp">
          {/* Inner rim details */}
          <div className="absolute inset-1 rounded-full border-2 border-dashed border-[#333]" data-id="element-430" data-mp="rqmj12r69rjl"></div>
          <div className="absolute inset-3 rounded-full border border-[#222] bg-[#111]" data-id="element-431" data-mp="dreh423mk5bp"></div>
        </div>
        {/* Lightning Bolt */}
        <Zap className="relative z-10 w-6 h-6 text-brand-gold fill-brand-gold drop-shadow-[0_0_5px_rgba(1,140,225,0.5)]" data-id="element-432" data-mp="hvm6m1hwppaz" />
      </div>
      {showText && <div className="flex flex-col" data-id="element-433" data-mp="32ks1ytdbaenj">
          <span translate="no" className="notranslate font-heading text-2xl leading-none tracking-wider text-brand-white" data-id="element-434" data-mp="32hnqrc1fiind">
            FLASH <span className="text-brand-gold" data-id="element-435" data-mp="19x860p081qn6">&amp;</span> GO
          </span>
        </div>}
    </div>;
}